import { Button } from "@-/dev.improve.haniverse.components.ui.button";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";

export function WordSectionExpansionButton({
  expanded,
  onPress,
  section,
}: {
  expanded: boolean;
  onPress: () => void;
  section: string;
}) {
  return (
    <Button
      accessibilityLabel={`${expanded ? "Collapse" : "Expand"} ${section} word details`}
      accessibilityState={{ expanded }}
      className="size-8 shrink-0 p-0"
      onPress={onPress}
      size="xs"
      variant="ghost"
    >
      <Text className="text-xl">{expanded ? "−" : "+"}</Text>
    </Button>
  );
}
